import { get } from '@api/request';

export async function getPropUseData(
  { litigationService },
  authenticationToken,
  { pYear },
) {
  let url = `${litigationService}/litigation/dashboard/propuse?pYear=${pYear === 'All' ? 0 : pYear}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function getTotalCases(
  { litigationService },
  authenticationToken,
  { pYear },
) {
  let url = `${litigationService}/litigation/dashboard/totalcases?pYear=${pYear === 'All' ? 0 : pYear}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function getUpcoming(
  { litigationService },
  authenticationToken,
  { pYear, finalized },
) {
  let url = `${litigationService}/litigation/dashboard/upcoming?finalized=${finalized}&pYear=${pYear === 'All' ? 0 : pYear}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function getStatusBreakdown(
  { litigationService },
  authenticationToken,
  { pYear, finalized },
) {
  let url = `${litigationService}/litigation/dashboard/status?finalized=${finalized}&pYear=${pYear === 'All' ? 0 : pYear}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function getTimeline(
  { litigationService },
  authenticationToken,
  { pYear },
) {
  let url = `${litigationService}/litigation/dashboard/timeline?pYear=${pYear === 'All' ? 0 : pYear}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function getPropTypes(
  { appealsService },
  authenticationToken,
  { pYear },
) {
  const url = `${appealsService}/prodigyappeals/appealsdashboard/proptype/${pYear}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function getDashboardDetail(
  { appealsService },
  authenticationToken,
  { type },
) {
  const url = `${appealsService}/prodigyappeals/appealsdashboard/dashboard/${type}/details`;
  const { body } = await get(authenticationToken, url);
  return body;
}
